(function () {
    'use strict';

    angular
        .module('app')
        .controller('LinePlanController', lController);

    function lController($scope, $cookies, $location, $rootScope, $filter, $timeout, $state, $stateParams, $window,
        LinePlanService, BriefService, PatternService, PrototypeService, toaster) {
        var model = this;
        $rootScope.lpId = $stateParams.lpId; //assign line plan id
        $rootScope.bId = $stateParams.bId; //assign brief id
        $rootScope.pId = $stateParams.pId; //assign pattern id
        $rootScope.cId = $stateParams.cId; //assign colorway id

        function loadData(id) {
            LinePlanService.getLinePlanHeaderInfo(id)
           .then(function (data) {
               model.linePlan = data;
               if (!data) {
                   alert('Incorrect Id, redirecting to home');
                   $state.go('home');
               }
           });
        }
        //load the data
        loadData($rootScope.lpId);
    }
})();
